export const MONOGRAM = "/brand/monogram.jpeg";

export const EDITORIAL = {
  heroMale: "/products/hyeaman-01-midnight-tailoring.png",
  female: "/products/hyeaman-02-ivory-architecture.png",
  goldJacketMan: "/products/hyeaman-03-emerald-night-utility.png",
  tieMan: "/products/hyeaman-04-cobalt-motion.png",
  darkPortrait: "/products/hyeaman-05-burgundy-deconstruction.png",
  blackLabel: "/products/mens-01-front-view.png",
};

// Rotating hero campaign set — new HYEAMAN campaigns + the returning previous campaigns.
export const CAMPAIGNS = [
  "/products/hyeaman-01-midnight-tailoring.png",
  "/products/hyeaman-02-ivory-architecture.png",
  "/products/hyeaman-03-emerald-night-utility.png",
  "/products/hyeaman-04-cobalt-motion.png",
  "/products/hyeaman-05-burgundy-deconstruction.png",
  "https://images.unsplash.com/photo-1657114104870-9e264105a476?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1765064067555-3a9e7b4d338c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1668640450699-b2e7d5b6740d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1783379793564-4507f62122c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1634733049839-0292be607569?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "/products/HYEAMAN-mens-streetwear-collection.png",
  "/products/HYEAMAN-ladies-streetwear-collection.png",
];

export const DEPARTMENTS = [
  { key: "men", label: "Men" },
  { key: "ladies", label: "Ladies" },
  { key: "unisex", label: "Unisex" },
  { key: "prince", label: "Prince" },
  { key: "princess", label: "Princess" },
];

export const COLLECTIONS = [
  { key: "street-sheriff", label: "Street Sheriff", note: "Global luxury streetwear. Urban armour. Nobody left behind." },
  { key: "black-label", label: "Black Label", note: "The pinnacle. Numbered, limited, uncompromising." },
  { key: "essentials", label: "Essentials", note: "Foundational pieces engineered to be worn daily." },
  { key: "elite", label: "Elite", note: "Statement outerwear with matte gold hardware." },
  { key: "athletic", label: "Athletic", note: "Technical performance built for movement." },
];

export const BRAND_VALUES = [
  "WEAR CONFIDENCE", "NO ONE IS LEFT BEHIND", "STREET SHERIFF",
  "BUILT FOR GREATNESS", "CROWN YOUR CULTURE", "EDITORIAL STREETWEAR",
  "LIMITED DROPS", "CRAFTED IN DETAIL",
];

export const collectionLabel = (k) => (COLLECTIONS.find((c) => c.key === k)?.label || k);
export const deptLabel = (k) => (DEPARTMENTS.find((d) => d.key === k)?.label || k);
export const money = (n) => `C$${Number(n).toFixed(2)}`;

export const COLOR_HEX = {
  Black: "#141414", Midnight: "#151a2b", Obsidian: "#16181c", Graphite: "#45474b", Charcoal: "#3a3a3c",
  Grey: "#9a978f", White: "#f5f4ef", Ivory: "#efe9dc", Cream: "#f4f0e8", Bone: "#e7e0cf", Pearl: "#eae5dc",
  Stone: "#c8c1b2", Tan: "#c9a37a", Sandstorm: "#d8c39a", Sage: "#9aa889", Forest: "#2f3d2f",
  Emerald: "#1f5f4a", Cobalt: "#2b4a8b", Blue: "#3f6fb0", Navy: "#1c2740", Oxblood: "#5a2024",
  Burgundy: "#5e2230", Terracotta: "#b06a4a", Taupe: "#8a7d6b", Pink: "#e6a8c0",
  Sand: "#d9c4a3", Indigo: "#33395e", Champagne: "#e6d3a3", Blush: "#e8b7b0", Rose: "#c98a8f", Olive: "#6b6a3c",
};
const LIGHT_COLORS = new Set(["White", "Ivory", "Cream", "Bone", "Pearl", "Stone", "Tan", "Sandstorm", "Sage", "Grey", "Taupe", "Pink", "Sand", "Champagne", "Blush", "Rose"]);
export const colorHex = (name) => COLOR_HEX[name] || "#8a857b";
export const isLightColor = (name) => LIGHT_COLORS.has(name);
